import { gql } from '@apollo/client';

export const GET_NEWS_ITEMS = gql`
  query GET_NEWS_ITEMS($perPage: Int, $page: Int, $originatorId: ID!){
    newsItems(perPage: $perPage, page: $page, originatorId: $originatorId) {
      __typename
      id
      content
      createdAt
      header
      updatedAt
    }    
  }
`